export default __webpack_public_path__ + "static/media/marketing.ce950fe9.jpg";